import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { OrdersReport } from './pages/OrdersReport';
import { EsimReport } from './pages/EsimReport';
import { TopUp } from './pages/TopUp';
import { UserManagement } from './pages/UserManagement';
import { PackageManagement } from './pages/PackageManagement';
import { Settings } from './pages/Settings';
import { DriverUsers } from './pages/DriverUsers';
import { DriverAudit } from './pages/DriverAudit';
import { DriverJobs } from './pages/DriverJobs';
import { BackgroundJobsDashboard } from './pages/BackgroundJobsDashboard';
import { Layout } from './components/layout/Layout';
import { Login } from './pages/Login';
import { AuthProvider, useAuth } from './context/AuthContext';
// Protected route component that checks user role
const ProtectedRoute = ({
  element,
  allowedRoles
}) => {
  const {
    user,
    isAuthenticated
  } = useAuth();
  if (!isAuthenticated) {
    console.log('Not authenticated, redirecting to login'); // Debug log
    return <Navigate to="/login" />;
  }
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    console.log('User role not allowed:', user.role); // Debug log
    return <Navigate to="/orders" />;
  }
  return element;
};
export function App() {
  return <AuthProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute element={<Layout />} allowedRoles={['admin', 'support']} />}>
            <Route index element={<Navigate to="/orders" replace />} />
            <Route path="orders" element={<OrdersReport />} />
            <Route path="esims" element={<EsimReport />} />
            <Route path="topup" element={<TopUp />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="packages" element={<ProtectedRoute element={<PackageManagement />} allowedRoles={['admin']} />} />
            <Route path="settings" element={<ProtectedRoute element={<Settings />} allowedRoles={['admin']} />} />
            {/* Driver Management Routes */}
            <Route path="driver-users" element={<DriverUsers />} />
            <Route path="driver-audit" element={<DriverAudit />} />
            <Route path="driver-jobs" element={<DriverJobs />} />
            <Route path="background-jobs" element={<BackgroundJobsDashboard />} />
          </Route>
          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </AuthProvider>;
}